// observe opus cart



    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      const promise = originalFetch.apply(this, arguments);
      const opusShadowContainer = document.querySelector('section#opus-shadow-container');
      //const rewardsContainer = document.querySelector('.cd-rewards-container');
      const rewardsContainer = document.querySelector("#opus-shadow-container").shadowRoot.querySelector("#opus-scroll-element-id > div > div.cdr-main-color.scrollbar-hide > div.cd-rewards-container");
      
      if (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change') ) {
        promise.then(response => {
          //console.log('Cart was modified!');
          //console.log(url);
          
          // Clone the response so we can use it twice
          // (once for our code and once for the original call)
          return response.clone().json().then(data => {
            // Handle both possible response structures
            const totalPrice = data._data ? data._data.total_price : data.total_price;
            const lineItemPrice = data._data ? data._data.original_line_price : data.original_line_price;
            const productArray = ['wellements-organic-constipation-support-twin-pack','wellements-organic-gripe-water-combo-pack','wellements®-3-piece-baby-feel-better-kit'];

            
            let addedItem = false;
            let cartItem = false;   
            //console.log(data);
            if(data.handle){
           // console.log('added '+data.handle);
              if (productArray.includes(data.handle)){
                //console.log('item found added');
                addedItem = true;
              }
            }
            if(data.items){
            data.items.forEach(item => {
              // Accessing each item in the array
              if (productArray.includes(item.handle)){
                //console.log('item found');
                cartItem = true;
              }
              //console.log("Title:", item.handle);
              //console.log("-----------------------------");
            });
                     
            }           
            
            
            // Log the total price in cents
            //console.log('Updated cart total price (cents):', totalPrice);
            
            
            // Format and log the price in dollars
            var totalPriceInDollars = totalPrice / 100;
            var lineItemPriceInDollars = lineItemPrice / 100;
            //console.log('addedItem:'+addedItem);
            //console.log('cartItem:'+cartItem);
    
            if (totalPrice === undefined ) {
                      totalPriceInDollars = lineItemPriceInDollars;
                       // Adding a class to .generated element, when it has been detected
                      waitForElement('.cd-rewards-container').then((element) => {	
                      	//var rewardsContainer2 = document.querySelector('.cd-rewards-container');
                        var rewardsContainer2 = document.querySelector("#opus-shadow-container").shadowRoot.querySelector("#opus-scroll-element-id > div > div.cdr-main-color.scrollbar-hide > div.cd-rewards-container");
                        
                         if(totalPriceInDollars >= 35 || addedItem == true || cartItem == true){
                            //console.log('greater than 35 first load');
                             if (rewardsContainer2) {
                                rewardsContainer2.classList.remove('under35');
                                rewardsContainer2.classList.add('over35');
                                //console.log('Applied new class over35 first load');
                              } 
                          }else{
                           //console.log('< than 35 first load');
                            if (rewardsContainer2) {
                                rewardsContainer2.classList.remove('over35');
                                rewardsContainer2.classList.add('under35');
                                //console.log('Applied new class under35 first load');
                              } 
                          }
                      
                       });   
            
                  
            }else{
                if(totalPriceInDollars >= 35 || addedItem == true || cartItem == true ){
                  //console.log('greater than 35');
                   if (rewardsContainer) {
                      rewardsContainer.classList.remove('under35');
                      rewardsContainer.classList.add('over35');
                      //console.log('Applied new class over35');
                    } 
                }else{
                  //console.log('greater than 35 first load');
                  if (rewardsContainer) {
                      rewardsContainer.classList.remove('over35');
                      rewardsContainer.classList.add('under35');
                      //console.log('Applied new class under35');
                    } 
                }
              }

            //console.log('Updated cart total price:', `$${totalPriceInDollars.toFixed(2)}`);
            
            return response;
          });
        });
      }
      
      return promise;
    };





/*
// Function to wait for an element and to detect it	
function waitForElement(selector) {
	return new Promise(resolve => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer1 = new MutationObserver(mutations => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer1.disconnect();
			}
		});

		observer1.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
};
*/

// Function to wait for an element and to detect it	
function waitForElement(selector) {
	return new Promise(resolve => {
		if (document.querySelector("#opus-shadow-container").shadowRoot.querySelector("#opus-scroll-element-id > div > div.cdr-main-color.scrollbar-hide > div.cd-rewards-container")) {
			return resolve(document.querySelector("#opus-shadow-container").shadowRoot.querySelector("#opus-scroll-element-id > div > div.cdr-main-color.scrollbar-hide > div.cd-rewards-container"));
		}

		const observer1 = new MutationObserver(mutations => {
			if (document.querySelector("#opus-shadow-container").shadowRoot.querySelector("#opus-scroll-element-id > div > div.cdr-main-color.scrollbar-hide > div.cd-rewards-container")) {
				resolve(document.querySelector("#opus-shadow-container").shadowRoot.querySelector("#opus-scroll-element-id > div > div.cdr-main-color.scrollbar-hide > div.cd-rewards-container"));
				observer1.disconnect();
			}
		});

		observer1.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
};



/// 4.7.25 function to wait for element in shadow root
 /*
  function waitForShadowRoot(element) {
      return new Promise(resolve => {
        const checkInterval = setInterval(() => {
          if (element.shadowRoot) {
            clearInterval(checkInterval);
            resolve(element.shadowRoot);
          }
        }, 100); // Check every 100ms
    
        // Optional timeout to prevent indefinite waiting
        setTimeout(() => {
          clearInterval(checkInterval);
          resolve(null); // Resolve with null if shadow root is not found within timeout
        }, 5000); // Timeout after 5 seconds
      });
    }
    
    async function observeElementInShadowRoot() {
      const hostElement = document.querySelector('section#opus-shadow-container');
      const shadowRoot = await waitForShadowRoot(hostElement);
    
      if (shadowRoot) {
        // Proceed with observer setup and observation
        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(node => {
                  if (node.matches('#target-element')) {
                    console.log('Target element added:', node);
                    observer.disconnect();
                  }
                });
              } else if (mutation.removedNodes.length) {
                mutation.removedNodes.forEach(node => {
                  if (node.matches('#target-element')) {
                    console.log('Target element removed:', node);
                    observer.disconnect();
                  }
                });
              }
            }
          }
        });
    
        observer.observe(shadowRoot, { childList: true, subtree: true });
      } else {
        console.error('Shadow root not found.');
      }
    }
    
    observeElementInShadowRoot(); */


